//
// MobileBIClientURL.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/TransportModel";
import "./MobileBIClientURLAction";

var MobileBIClientURL = createModule("transport::MobileBIClientURL", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        hostname: 7,
        password: 7,
        scheme: 7,
        port: 4,
        description: 7,
        action: 4,
        section: 7,
        guest: 2,
        userid: 7,
        reportLocation: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default MobileBIClientURL;
